import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ERROR_MSG, SUCCESS_MSG } from '../../shared/errorMessages';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-change-forgot-password',
  templateUrl: './change-forgot-password.component.html',
  styleUrls: ['./change-forgot-password.component.scss']
})
export class ChangeForgotPasswordComponent implements OnInit {
  loginForm: FormGroup;
  isLoading: boolean = false;
  passwordIsActive: boolean = false;
  passwordIsActive2: boolean = false;
  formErrors = {
    'newPassword': ''
  };
  validationMessages = {
    'newPassword': {
      'required': 'Por favor ingrese su contraseña'
    }
  };
  token: string;
  confirmPassMsg: string = 'Ingrese nuevamente la contraseña';

  constructor(private fb: FormBuilder, private authServ: AuthService,
    private _snackBar: MatSnackBar, private route: ActivatedRoute,
    private router: Router) {

    this.createForm();
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
  }

  createForm() {
    this.loginForm = this.fb.group({
      newPassword: ['', [Validators.required]]
    });

    this.loginForm.valueChanges
      .subscribe(data => this.onValueChanged(data));

    this.onValueChanged();
  }

  onValueChanged(data?: any) {
    if (!this.loginForm) { return; }
    const form = this.loginForm;
    for (const field in this.formErrors) {
      if (this.formErrors.hasOwnProperty(field)) {
        // clear previous error message (if any)
        this.formErrors[field] = '';
        const control = form.get(field);
        if (control && control.dirty && !control.valid) {
          const messages = this.validationMessages[field];
          for (const key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              this.formErrors[field] += messages[key] + ' ';
            }
          }
        }
      }
    }
  }

  verifyPassword(value: string) {
    if (value !== this.loginForm.value.newPassword) {
      this.confirmPassMsg = "Las contraseñas no coinciden";
    } else {
      this.confirmPassMsg = "";
    }
  }


  changePassword() {
    this.isLoading = true;
    this.authServ.resetPassword(this.token, this.loginForm.value.newPassword).then(res => {
      this.isLoading = false;
      if (res.success) {
        this._snackBar.open(SUCCESS_MSG['SUCCESS_UPDATED'], null, {
          duration: 3000,
        });
        this.router.navigate(['/login'])
      } else {
        this._snackBar.open(res.data, null, {
          duration: 3000,
        });
      }
    }).catch(error => {
      this.isLoading = false;
      this._snackBar.open(ERROR_MSG[error.code], null, {
        duration: 3000,
      });
    });
  }

}
